import CoreComponent from './Core';

class BaseModal extends CoreComponent {
    constructor(props, subModuleName,id_to_edit,parent_component) {
      super(props);
      this.state = {
        list_url: '/api/organ/' + subModuleName + '/',
        get_url: '/api/organ/' + subModuleName + '/',
        form_data: null,
        form_width: "90%",
        form_background: "#ecf0f5",
        id_to_edit: id_to_edit,
        extra_fields:null,
        element_id: this.uuidv4(),
        parent_component:parent_component,
        show_remove_button:false,
        //فیلد شناسه اصلی جهت استفاده در مواردی نظبر حذف
        key:'',
        //برای نمایش خطاها به صورت مجموعه ای
        messages: []
      };
    }
    showRemoveButton(){
      this.setState({show_remove_button:true});
    }
    componentDidMount() {
      if (this.state.id_to_edit==null || this.state.id_to_edit==0)
        this.openNewForm();
      else
        this.openModifyForm();//this.state.id_to_edit
    }
    componentWillReceiveProps(props){
      this.state.id_to_edit = props.Id;
      this.state.showLog = false;
      if (this.state.id_to_edit==null || this.state.id_to_edit==0)
        this.openNewForm();
      else
        this.openModifyForm();//this.state.id_to_edit
    }
    componentDidUpdate(){
    }
    openNewForm() {
      this.lockScreen();
      this.setState({ id_to_edit: 0 });
      var get_url = '/api/organ/' + this.state.subModuleName + '/';
      fetch(get_url, {
        method: 'POST',
        body: JSON.stringify({
          "action": "new",
          "extra_fields":this.state.extra_fields
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(form_data => {
        this.setState({ form_data });
        this.unLockScreen();
      }
      ).catch(err=>{
        this.showToast("خطایی در نمایش اطلاعات پیش آمده است.","danger");
        this.unLockScreen();
      });
    }
    openModifyForm() {
      this.lockScreen();
      //this.setState({ id_to_edit: id });
      var get_url = '/api/organ/' + this.state.subModuleName + '/';
      fetch(get_url, {
        method: 'POST',
        body: JSON.stringify({
          "action": "get",
          "id": this.state.id_to_edit,
          "subModuleName": this.state.subModuleName,
          "extra_fields":this.state.extra_fields
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(form_data => {
        this.setState({ form_data });
        this.unLockScreen();
      }).catch(err=>{
          this.showToast('خطایی در نمایش اطلاعات رخ داده است.','danger');
          this.unLockScreen();
      });
    }
    setFormValue(t, n, isEditor = false) {
      if (t === null)
      {
        this.state.form_data.record[n] = null;
        return ;
      }
      if (isEditor == false)
      {
        let isCheckBox=false;
        if (t.value===undefined)
          if (t.target.type!=undefined)
            if (t.target.type==='checkbox')
              isCheckBox=true;
        if(isCheckBox)
        {
            this.state.form_data.record[n] = t.target.checked ? "1" : "0"; //t.target.checked;
        }
        else
          if (t.value!=undefined)
            this.state.form_data.record[n] = t.value;
          else
          {
              this.state.form_data.record[n] = t.target.value;
          }
      }
      else{
        this.state.form_data.record[n] = t.getContent();
      }
    }
    setDateValue(t, n) {
      this.state.form_data.record[n] = t;
    }
    closeForm() {
      this.state.form_data = null;
      this.state.showProfile = false;
      this.setState({form_data:null,showProfile:false});
      if (this.state.parent_component != undefined && this.state.parent_component != null)
      {
        this.state.parent_component.state.id_to_edit = null;
        this.state.parent_component.state.showLog = false;
        this.state.parent_component.setState({id_to_edit:null,showLog:false});
      }
    }
    back(){
      //ادرس مسیر جاری رو بدست میاره و اسم دامین و پروتکل رو از ادرس حذف میکنه
      var u = window.location.href.toString().replace(window.location.origin+'/organ/','/');

      if (u.substr(-1)!='/') u = u + "/";
      
      //چون ابتدا و انتها اسلش داریم داریم برای همین بایستی توجه بشه که اندیس اول و اخر ارایه خالی خواهد بو
      u = u.toLocaleLowerCase();
      let urlSections = u.split("/");
      // module/action/id

      // in specialpersons
      // module/legalid/action/id
      this.go('/' + urlSections[1] + "/");
    }
    saveForm(op='') {
      this.setState({messages: []});
      this.lockScreen();
      let type = "add";
      if (this.state.id_to_edit == 0)
        type = "add";
      else
        type = "edit";

      var get_url = '/api/organ/' + this.state.subModuleName + '/';
      fetch(get_url, {
        method: 'POST',
        body: JSON.stringify({
          "action": type,
          "form": this.state.form_data.record,
          //این بخش در بعضی جاها نیاز هست
          "medias":this.state.form_data.medias
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then((resualt) => {
        this.unLockScreen();
        if (resualt.status == 1) {
          this.showToast('اطلاعات با موفقیت ذخیره شد.','success');

          if (!this.isBlank(resualt.url)){
            this.go(resualt.url);
            return;
          }
          //ادرس مسیر جاری رو بدست میاره و اسم دامین و پروتکل رو از ادرس حذف میکنه
          var u = window.location.href.toString().replace(window.location.origin+'/organ/','/');

          if (u.substr(-1)!='/') u = u + "/";
          
          //چون ابتدا و انتها اسلش داریم داریم برای همین بایستی توجه بشه که اندیس اول و اخر ارایه خالی خواهد بو
          u = u.toLocaleLowerCase();
          let urlSections = u.split("/");
          // module/action/id

          // in specialpersons
          // module/legalid/action/id

          if (op === '') {
            if (urlSections[2] === "edit")
            {
              window.location.reload();
              return;
            }
            if (urlSections[2] === "new")
              this.go('/' + urlSections[1] + "/edit/" + resualt.id + "/");
          }
          else{
            if (op === 'return')
              this.go('/' + urlSections[1] + "/");
            else
              window.location.href = window.location.origin + op + resualt.id ;
          }
        }
        else
        {
          if (resualt.message === undefined && resualt.messages == undefined)
          this.showToast('برنامه قادر به اجرای درخواست شما نمی باشد.','danger');
          else{
            if (resualt.messages != undefined){
              this.setState({messages: resualt.messages});
              this.showToast("لطفا خطاهای نمایش داده شده را برطرف نمایید",'warning');
              if (typeof window !== "undefined")
                  window.scrollTo(0, 0);
            }
            else{
              this.showToast(resualt.message,'warning');
            }
          }
        }
      })
      //.catch(err=>{
      //  this.unLockScreen();
      //  this.showToast('برنامه قادر به اجرای درخواست شما نمی باشد.','danger');
      //});
    }
    render() {
      return null;
    }
  }
  export default BaseModal;